import SectionHeading, { Reveal } from "@/components/SectionHeading";

export default function CtaBanner({ onJoin }) {
  return (
    <section
      data-testid="cta-banner-section"
      className="relative bg-[#1A1A1A] border-y border-[#FF5A1F]/40 py-20 md:py-24 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, #FF5A1F 0px, #FF5A1F 2px, transparent 2px, transparent 18px)",
        }}
      />
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-heading text-[18rem] leading-none text-outline whitespace-nowrap hidden md:block"
      >
        F12
      </span>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl uppercase leading-none tracking-wide text-white">
            Your Next Level <span className="text-[#FF5A1F]">Starts Here.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#D1D1D1] max-w-xl mx-auto">
            Step into the gym. Build your strength. Achieve your goals.
          </p>
          <button
            data-testid="cta-join-community-button"
            onClick={onJoin}
            className="mt-10 inline-flex items-center justify-center bg-[#FF5A1F] hover:bg-[#E0480F] text-white font-heading text-xl tracking-widest px-10 py-4 rounded-sm transition-colors shadow-[0_0_35px_rgba(255,90,31,0.45)]"
          >
            JOIN OUR FITNESS COMMUNITY
          </button>
        </Reveal>
      </div>
    </section>
  );
}
